import {SaleVehicleAlbumPhotoResponseBody} from '@dms/api/vehicle';

import {UnifiedAlbumImage} from '../types/UnifiedAlbumImage';

export const toUnifiedAlbumImage = (
  image: SaleVehicleAlbumPhotoResponseBody
): UnifiedAlbumImage => ({
  ...image,
  url: image.url.replace('/get/', '/resize/'),
  isPromoPhoto: false,
});
